import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n';
import ReactDOM from 'react-dom';
import './EconomyStyle.scss';
class Tooltip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShow: false,
      top: null,
      left: null,
    };
    this.div = document.createElement('div');
    this.rootRef = React.createRef();
    this.tooltipRef = React.createRef();
  }

  componentDidUpdate(prevProps, prevState) {
    const { isShow } = this.state;
    if (isShow && !prevState.isShow) {
      const { top, left } = this.getTooltipPos();
      this.setState({
        top,
        left,
      });
    }
  }

  getTooltipPos = () => {
    const {
      right: rootRight,
      top: rootTop,
      height: rootHeight,
    } = this.rootRef.current.getBoundingClientRect();
    const {
      height: tooltipHeight,
    } = this.tooltipRef.current.getBoundingClientRect();
    const centerRoot = rootTop + rootHeight / 2;
    const top = centerRoot - tooltipHeight / 2;
    return {
      top,
      left: rootRight + 6,
    };
  };

  hideTooltip = () => {
    this.setState({ isShow: false });
  };

  showTooltip = () => {
    document.body.appendChild(this.div);
    this.setState({ isShow: true });
  };

  renderTooltip = () => {
    const { top, left } = this.state;
    const { message, messageFiin } = this.props;
    return (
      <div
        ref={this.tooltipRef}
        style={{
          top: top || 9999,
          left: left || 9999,
        }}
        className="tooltip-bubble position-fixed"
      >
        <div className="tooltip-message text-left d-flex flex-column">
          <div>
            {I18n.t('economy.originalPost')}
            <a href={message} rel="noreferrer noopener" target="_blank">
              {message ? message.substring(0, 15) : ''}
            </a>
          </div>
          <div className="mt-2">
            {I18n.t('economy.fiinGroupReview')}
            <a href={messageFiin} rel="noreferrer noopener" target="_blank">
              {messageFiin ? messageFiin.substring(0, 12) : ''}
            </a>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { isShow } = this.state;
    const { children } = this.props;
    return (
      <div className="tooltip-watchlist" onMouseLeave={this.hideTooltip}>
        {isShow && ReactDOM.createPortal(this.renderTooltip(), this.div)}
        <div
          ref={this.rootRef}
          className="d-inline"
          onMouseOver={this.showTooltip}
        >
          {children}
        </div>
      </div>
    );
  }
}

export default Tooltip;
